import React from 'react';
import PropTypes from 'prop-types';
import Toast from "../../../../../components/WMS/Toast";
import RedWarning from "../../../../../assets/img/redWarning.svg";
import {FormattedMessage} from "react-intl";

AddProductFromRetailerNotFound.propTypes = {
    open: PropTypes.bool,
    handleClose: PropTypes.func
};

function AddProductFromRetailerNotFound({open = false, handleClose = () => {}}) {
 return (
     <Toast
         icon={(
             <img
                 src={RedWarning}
                 alt={<FormattedMessage id={'wms.myPickingMissions.productFromRetailer.notFound.title'}/>}
                 style={{width: '20px', height: '20px'}}
             />
         )}
         title={<FormattedMessage id={'wms.myPickingMissions.productFromRetailer.notFound.title'} />}
         open={open}
         handleClose={handleClose}
         disablePortal={false}
     />
 );
}

export default AddProductFromRetailerNotFound;